import React, { useState, useEffect } from 'react';
import { TrendingUp, MapPin } from 'lucide-react';

export const SocialProofBar = () => {
  const [count, setCount] = useState(3);
  const [location, setLocation] = useState('Hamburg');
  
  const locations = ['Hamburg', 'Norderstedt', 'Pinneberg', 'Ahrensburg', 'Wedel'];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCount(Math.floor(Math.random() * 5) + 2);
      setLocation(locations[Math.floor(Math.random() * locations.length)]);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-brand-green/10 border-t border-b border-brand-green/20 py-4">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-center gap-3 text-sm">
          <TrendingUp className="w-4 h-4 text-brand-green animate-pulse" />
          <span className="text-gray-700">
            <strong className="text-brand-green font-semibold">{count} Anfragen</strong> heute in
          </span>
          <div className="flex items-center gap-1">
            <MapPin className="w-4 h-4 text-brand-green" />
            <strong className="text-gray-900">{location}</strong>
          </div>
        </div>
      </div>
    </div>
  );
};